import * as z from "zod/v4";

export const getSegmentProductVendors = {
  name: "getSegmentProductVendors" as const,
  input: z.null(),
  output: z.array(z.string()),
};
